<ng-container [ngSwitch]="step">
  <perch-icons-step-one *ngSwitchCase="1"></perch-icons-step-one>
  <perch-icons-step-two *ngSwitchCase="2"></perch-icons-step-two>
  <perch-icons-step-three *ngSwitchCase="3"></perch-icons-step-three>
  <perch-icons-step-four *ngSwitchCase="4"></perch-icons-step-four>
</ng-container>
